import { JSX } from "react";

import { IconProps } from "@/@types/general.ts";

const IconBookmarkSimple = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={"1.5rem"} height={"1.5rem"} viewBox="0 0 24 24" {...props}>
    <path
      d="M18 20L12 15.5556L6 20V5.77778C6 5.30628 6.18061 4.8541 6.5021 4.5207C6.82359 4.1873 7.25963 4 7.71429 4H16.2857C16.7404 4 17.1764 4.1873 17.4979 4.5207C17.8194 4.8541 18 5.30628 18 5.77778V20Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconBookmarkSimple;
